export const showTime = () => {
  const $time = document.getElementById('time') || new HTMLDivElement();
  const $date = document.getElementById('date') || new HTMLDivElement();

  setInterval(() => {
    const time = new Intl.DateTimeFormat('en-AU', {
      timeStyle: 'short',
      timeZone: 'Australia/Sydney',
    }).format(new Date());
    $time.innerText = time;
    const date = new Intl.DateTimeFormat('en-AU', {
      day: 'numeric',
      month: 'short',
      weekday: 'short',
      year: 'numeric',
      timeZone: 'Australia/Sydney',
    }).format(new Date());
    $date.innerText = date;
  }, 1000);
};
